import { BuildConfig } from '../config/BuildConfig'
import Popup from '../components/Popup'
import React from 'react'
import { WarningPopupGraphic } from '../components/WarningPopupGraphic'
import { VersionTag } from '../components/VersionTag'

export function ClipspecConnectionErrorPopup(props: { errorCode: string }) {
  const copy = BuildConfig.brand.copy.Clipspec.ConnectionErrorPopup

  return (
    <Popup
      fullscreen
      onClose={() => {
        return
      }}
    >
      <WarningPopupGraphic />
      <div className="title">
        {copy.Title}
      </div>
      <div style={{ textAlign: 'center' }}>
        {copy.Subtitle}
        <div style={{ color: 'grey' }}>
          {copy.ErrorCode} {props.errorCode}
          <br/>
        </div>
        <p>
          {copy.Body}
        </p>
      </div>

      {/* separate overlaying element outside the popup content */}
      <div style={{ position: 'fixed', right: '8px', bottom: '4px' }}>
        <VersionTag dark />
      </div>
    </Popup>
  )
}